import * as actionTypes from "./constants";
import * as Service from "./service";

const getStatusData = (params, id) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_STATUS_DATA_REQUEST });
            const res = await Service.getStatusData(params, id);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_STATUS_DATA_SUCCESS,
                        response: regionData
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_STATUS_DATA_FAILURE,
                        error: regionData
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_STATUS_DATA_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_STATUS_DATA_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const updateStatus = (statusId, params, getParams) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_STATUS_REQUEST });
            const res = await Service.updateStatus(statusId, params);
            if (res && (res.status === 200 || res.status === 201)) {
                const response = res.data;
                if (response.success) {
                    dispatch({
                        type: actionTypes.UPDATE_STATUS_SUCCESS,
                        response: response
                    });
                    dispatch(getStatusData(getParams));
                } else {
                    dispatch({
                        type: actionTypes.UPDATE_STATUS_FAILURE,
                        error: response
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_STATUS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_STATUS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const statusDropdown = projectId => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.STATUS_DROPDOWN_REQUEST });
            const res = await Service.statusDropdown(projectId);
            if (res && (res.status === 200 || res.status === 201)) {
                const response = res.data;
                if (response.success) {
                    dispatch({
                        type: actionTypes.STATUS_DROPDOWN_SUCCESS,
                        response: response
                    });
                } else {
                    dispatch({
                        type: actionTypes.STATUS_DROPDOWN_FAILURE,
                        error: response
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.STATUS_DROPDOWN_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.STATUS_DROPDOWN_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const updateStatusEntityParams = entityParams => {
    return async dispatch => {
        try {
            if (entityParams) {
                dispatch({
                    type: actionTypes.UPDATE_STATUS_ENTITY_PARAMS_SUCCESS,
                    response: entityParams
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_STATUS_ENTITY_PARAMS_FAILURE,
                error: entityParams
            });
        }
    };
};

const restoreStatusLog = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.RESTORE_STATUS_LOG_REQUEST });
            const res = await Service.restoreStatusLog(id);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.RESTORE_STATUS_LOG_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.RESTORE_STATUS_LOG_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.RESTORE_STATUS_LOG_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.RESTORE_STATUS_LOG_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const postStatus = (params, getParams) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.POST_STATUS_REQUEST });
            const res = await Service.postStatus(params);
            if (res && (res.status === 200 || res.status === 201)) {
                const response = res.data;
                if (response.success) {
                    dispatch({
                        type: actionTypes.POST_STATUS_SUCCESS,
                        response: response
                    });
                    dispatch(getStatusData(getParams));
                } else {
                    dispatch({
                        type: actionTypes.POST_STATUS_FAILURE,
                        error: response
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.POST_STATUS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.POST_STATUS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const deleteStatus = (id, getParams) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.DELETE_STATUS_REQUEST });
            const res = await Service.deleteStatus(id);
            if (res && (res.status === 200 || res.status === 201)) {
                const response = res.data;
                if (response.success) {
                    dispatch({
                        type: actionTypes.DELETE_STATUS_SUCCESS,
                        response: response
                    });
                    dispatch(getStatusData(getParams));
                } else {
                    dispatch({
                        type: actionTypes.DELETE_STATUS_FAILURE,
                        error: response
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.DELETE_STATUS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.DELETE_STATUS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

export default {
    getStatusData,
    updateStatus,
    updateStatusEntityParams,
    statusDropdown,
    restoreStatusLog,
    postStatus,
    deleteStatus
};
